import { Directive, EventEmitter, HostListener, Output, Input } from '@angular/core';

@Directive({
  selector: '[appLongPress]'
})
export class LongPressDirective {
  //The output event that will be triggered when is long pressed.
  @Output() longPress = new EventEmitter();

  // The time it takes to be considered a long press (default 500ms)
  @Input() duration: number = 500;

  private timer: any;
  private isMoved = false;

  constructor() { }

  // 1. Event: Touch start (on mobile) or mouse click (on PC)
  @HostListener('touchstart', ['$event'])
  @HostListener('mousedown', ['$event'])
  onPress(event: Event) {
    this.isMoved = false;
    
    // Запускаем таймер
    this.timer = setTimeout(() => {
      //If the timeout expires and the finger/mouse has not moved, we call the event
      if (!this.isMoved) {
        this.longPress.emit(event);
      }
    }, this.duration);
  }

  // 2. Event: finger movement
  @HostListener('touchmove')
  onMove() {
    // If the finger moves, we reset the timer and mark it as "movement"
    this.isMoved = true;
    clearTimeout(this.timer);
  }

  // 3. Event: Touch end or mouse button release
  @HostListener('touchend')
  @HostListener('mouseup')
  onRelease() {
    // Reset the timer when released
    clearTimeout(this.timer);
    this.isMoved = false;
  }
}
